const formList = {
    internalAccountManger:[
        {
            entityField: "start",
            fieldType: "date",
            formatterContent: null,
            isRequired: 0,
            isShow: 1,
            searchId: null,
            extractId: null,
            setField: null,
            showField: "开始时间",
        },
        {
            entityField: "end",
            fieldType: "date",
            formatterContent: null,
            isRequired: 0,
            isShow: 1,
            searchId: null,
            extractId: null,
            setField: null,
            showField: "结束时间",
        },
        {
            entityField: "planId",
            fieldType: "string",
            formatterContent: null,
            isRequired: 0,
            isShow: 1,
            searchId: "",
            extractId: null,
            setField: '',
            showField: "方案",
        },
        {
            entityField: "searchValue",
            fieldType: "radioButton",
            formatterContent: null,
            isRequired: 0,
            isShow: 1,
            searchId: "",
            extractId: null,
            setField: '',
            showField: "过滤条件",
        },
    ],
    voucherRecoverManager:[
        {
            entityField: "start",
            fieldType: "date",
            formatterContent: null,
            isRequired: 0,
            isShow: 1,
            searchId: null,
            extractId: null,
            setField: null,
            showField: "开始时间",
        },
        {
            entityField: "end",
            fieldType: "date",
            formatterContent: null,
            isRequired: 0,
            isShow: 1,
            searchId: null,
            extractId: null,
            setField: null,
            showField: "结束时间",
        },
        {
            entityField: "tpId",
            fieldType: "string",
            formatterContent: null,
            isRequired: 0,
            isShow: 1,
            searchId: "",
            extractId: null,
            setField: '',
            showField: "方案",
        },
        {
            entityField: "searchValue",
            fieldType: "radioButton",
            formatterContent: null,
            isRequired: 0,
            isShow: 1,
            searchId: "",
            extractId: null,
            setField: '',
            showField: "过滤条件",
        },
    ]
}
export default formList